/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Space_Access_Chip2_AnswerInputs */



/**
* | output |
* | --- |
* | "Only space administrators can manage access and permissions. Viewers can read files, editors can upload and embed, and admins can also manage members and set..." |
*
* @param {Uno_Edu_Space_Access_Chip2_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_space_access_chip2_answer = /** @type {((inputs?: Uno_Edu_Space_Access_Chip2_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Space_Access_Chip2_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur Space-Administratoren können Zugriff und Berechtigungen verwalten. Betrachter können Dateien lesen, Bearbeiter können hochladen und einbetten, und Administratoren können zusätzlich Mitglieder und Einstellungen verwalten.")
	return /** @type {LocalizedString} */ ("Only space administrators can manage access and permissions. Viewers can read files, editors can upload and embed, and admins can also manage members and settings.")
});